import { render, staticRenderFns } from "./despatchUnBillReporttable.vue?vue&type=template&id=3b3bb442&scoped=true&"
import script from "./despatchUnBillReporttable.vue?vue&type=script&lang=js&"
export * from "./despatchUnBillReporttable.vue?vue&type=script&lang=js&"
import style0 from "./despatchUnBillReporttable.vue?vue&type=style&index=0&id=3b3bb442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bb442",
  null
  
)

export default component.exports